export default {
  firebase: {
    apiKey: 'AIzaSyA6R2XQ9NsZSPx9H9uw_BOCbFHrK5w3Sjo',
    authDomain: 'gentle-map.firebaseapp.com',
    databaseURL: 'https://gentle-map.firebaseio.com',
    projectId: 'gentle-map',
    storageBucket: 'gentle-map.appspot.com',
    messagingSenderId: '882194276756',
    appId: '1:882194276756:web:31fa51ab6af20b6c',
    // custom option
    functions: {
      baseUrl: 'https://asia-northeast1-gentle-map.cloudfunctions.net'
    }
  },
  kakao: {
    appKey: 'b9a92ee752a335031c10f0a11e485f59',
    sdk: 'https://developers.kakao.com/sdk/js/kakao.min.js',
    baseUrl: 'https://dapi.kakao.com',
    restApiKey: 'KakaoAK 8abf1bc35f096ae2b379999747323a3a'
  }
}



// WEBPACK FOOTER //
// ./src/store/config.js